import Url from '../../../constants/environment';
import Api from '../../api';

class BannersService extends Api {
  constructor() {
    super();
  }

  /**
   * @description 내정보 가져오기
   * @returns
   */
  async getList() {
    return await this.commonAjax('get', Url.namedApi, `portal_api/get_banner.php`, {}, {}, false);
  }

  async submitSportBannerRequest(formData) {
    return await this.commonAjax('post', Url.named, `sport/banner/send-email`, formData, {}, false);
  }
}

export default new BannersService();
